export const HORIZONTAL = 'Horizontal';
export const VERTICAL = 'Vertical';
export const BASIC = 'Basic';
export const PARENT = 'Parent';
export const NUMBER_DROPDOWN = 'NumberDropdown';